import {CustomNodeData} from '../tabs/ReactFlowTab'
import {
    type Edge,
    type Node,
} from '@xyflow/react';

import { base64ToArrayBuffer } from '../RepresentationSelectorModal';
import { GLTFLoader } from 'three-stdlib';
import { LoadedModel } from '../tabs/ThreeDTab';

import axios from 'axios';
import config from '../../config';
import { Vector3 } from 'three/src/math/Vector3';


/**
 * Creates the component node and loads the 3D component 
 * @param {string}componentText 
 * @param {React.Dispatch<React.SetStateAction<Node<CustomNodeData>[]>>}  setNodes 
 */
export function CreateRepresentation(componentText:{ id: number; name: string ; content : string, hash : string}, setNodes: React.Dispatch<React.SetStateAction<Node<CustomNodeData>[]>>, setLoadedModels: React.Dispatch<React.SetStateAction<LoadedModel[]>>) {
    console.log('Creating representation with data:', componentText);

    const uniqueId = `${componentText.name}-${Date.now()}-${Math.random().toString(36)}`;

    // We add the node to the React Flow graph. The graph does not need node inputs/outputs for 3D representations
    const componentData = { type: '3d_representation',
                            object: {
                                _Properties: {
                                    representation_id :{_Value: componentText.id, _Type: "System.Int32"},
                                    representation_name:  {_Value: componentText.name, _Type: "System.String"},
                                    representation_unique_id: {_Value: uniqueId, _Type: "System.String"},
                                    representation_hash: {_Value: componentText.hash, _Type: "System.String"},
                                    pos_x: {_Value: 0.0, _Type: "System.Double"},
                                    pos_y: {_Value: 0.0, _Type: "System.Double"},
                                    pos_z: {_Value: 0.0, _Type: "System.Double"},
                                    scale_x: {_Value: 1.0, _Type: "System.Double"},
                                    scale_y: {_Value: 1.0, _Type: "System.Double"},
                                    scale_z: {_Value: 1.0, _Type: "System.Double"},
                                    rot_x: {_Value: 0.0, _Type: "System.Double"},
                                    rot_y: {_Value: 0.0, _Type: "System.Double"},
                                    rot_z: {_Value: 0.0, _Type: "System.Double"}
                                },
                            },
                        };

    console.log('hasta 1', componentData);
    const newNodeLabel = componentText.name || 'Component';
    const newNodeInputs = 0;
    const newNodeOutputs = 0;
    setNodes((nds) => {
                const id = (nds.length + 1).toString();
                const newNode: Node<CustomNodeData> = {
                    id,
                    data:  {
                        label: newNodeLabel || `Node ${id}`,
                        inputs: Array.from({ length: newNodeInputs }, (_, idx) => ({
                            name: `input${idx + 1}`,
                            type: 'default',
                        })),
                        outputs: Array.from({ length: newNodeOutputs }, (_, idx) => ({
                            name: `output${idx + 1}`,
                            type: 'default',
                        })),
                        custom_data: componentData
                    },
                    position: { x: 100 + nds.length * 50, y: 100 },
                    type: 'custom',
                };
                console.log('hasta 2')
                console.log('Nodo agregado:', newNode);
                return [...nds, newNode];
            });

    // Here you would add the logic to load and display the 3D representation using your preferred 3D library (e.g., Three.js, Babylon.js, etc.)

    try {
        const arrayBuffer = base64ToArrayBuffer(componentText.content);
        const loader = new GLTFLoader();
        loader.parse(arrayBuffer, '', (gltf) => {
            gltf.scene.scale.set(100, 100, 100);
            gltf.scene.traverse((child: any) => {
                if (child.isMesh && child.material) {
                    if (child.material.metalness !== undefined) child.material.metalness = 0.6;
                    if (child.material.roughness !== undefined) child.material.roughness = 0.3;
                    if (child.material.reflectivity !== undefined) child.material.reflectivity = 0.5;
                    child.material.needsUpdate = true;
                }
            });
            setLoadedModels(models => [...models, { id: uniqueId, type: 'gltf', scene: gltf.scene }]);
            // setScene(gltf.scene);
            // if (onFit) onFit(gltf.scene);
        }, (err) => {
            // setScene(null);
            
        });
    } catch (e) {
        // setScene(null);
    }
}


/**
 * This function restores the 3D representations from the given nodes
 * @param nodes 
 * @param setLoadedModels 
 */
export async function RestoreRepresentation(nodes: any[], setLoadedModels: React.Dispatch<React.SetStateAction<LoadedModel[]>>) {
    // Clear all loaded models at the beginning
    // setLoadedModels([]);

    // Node<CustomNodeData>[]

    axios.defaults.withCredentials = true;

    for (const node of nodes) {
        const data = node.data.custom_data;
        //if (data && (data.type === '3d_representation') || validate_representation_data(data)) {
        if (data && validate_representation_data(data)) {
            console.log('Restoring representation for node:', node);
            const representation_hash = data.object._Properties.representation_hash._Value || '';
            console.log('Hash:', representation_hash);
            if (representation_hash !== '') {
                const uniqueId = data.object._Properties.representation_unique_id?._Value || `restored-${Date.now()}-${Math.random().toString(36)}`;

                try {
                    const response = await axios.post(`${config.API_BASE_URL}/representation/get-representation-by-hash.php`, { hash: representation_hash });
                    if (response.data.success) {
                        console.log('Component data:', base64ToArrayBuffer(response.data.data.component));
                        const content = response.data.data.component;

                        try {
                            const arrayBuffer = base64ToArrayBuffer(content);
                            const loader = new GLTFLoader();
                            loader.parse(arrayBuffer, '', (gltf) => {
                                gltf.scene.scale.set(100, 100, 100);

                                setTimeout(() => {
                                    const dx = (parseFloat(data.object._Properties.pos_x._Value) * 100 || 0);
                                    const dy = (parseFloat(data.object._Properties.pos_y._Value) * 100 || 0);
                                    const dz = (parseFloat(data.object._Properties.pos_z._Value) * 100 || 0);

                                    gltf.scene.position.set(
                                        dx,
                                        dy,
                                        dz
                                    );

                                    gltf.scene.rotation.set(
                                        (parseFloat(data.object._Properties.rot_y._Value) || 0) * Math.PI / 180,
                                        (parseFloat(data.object._Properties.rot_x._Value) || 0) * Math.PI / 180,
                                        (parseFloat(data.object._Properties.rot_z._Value) || 0) * Math.PI / 180
                                    );

                                }, 2000);

                                // console.log('new component', gltf.scene);
                                gltf.scene.traverse((child: any) => {
                                    if (child.isMesh && child.material) {
                                        if (child.material.metalness !== undefined) child.material.metalness = 0.6;
                                        if (child.material.roughness !== undefined) child.material.roughness = 0.3;
                                        if (child.material.reflectivity !== undefined) child.material.reflectivity = 0.5;
                                        child.material.needsUpdate = true;
                                    }
                                });

                                setLoadedModels((models) => {
                                    console.log('Adding model to loadedModels:', uniqueId);
                                    return [...models, { id: uniqueId, type: 'gltf', scene: gltf.scene }];
                                });
                            });
                        } catch (e) {
                            console.error('Error parsing GLTF:', e);
                        }
                    }
                } catch (error) {
                    console.error('Error fetching component and display_table:', error);
                }
            }
        }
    }
}

/**
 * This function adds a 3D representation of the simulation component.
 * @param node_props 
 * @param setLoadedModels 
 */
export async function CreateSimulationRepresentation(node_props: CustomNodeData, setLoadedModels: React.Dispatch<React.SetStateAction<LoadedModel[]>>) {

    if (validate_representation_data(node_props.custom_data) === false) {
        console.error('Invalid representation data:', node_props);
        return;
    }
    console.log('Creating simulation representation with data:', node_props);
    
    const uniqueId = node_props.custom_data?.object?._Properties?.representation_unique_id?._Value;
    const representation_hash = node_props.custom_data?.object?._Properties?.representation_hash?._Value;

    console.log('Hash:', representation_hash);

    const data = node_props.custom_data;

    try {
        const response = await axios.post(`${config.API_BASE_URL}/representation/get-representation-by-hash.php`, { hash: representation_hash });
        if (response.data.success) {
            console.log('Component data:', base64ToArrayBuffer(response.data.data.component));
            const content = response.data.data.component;

            try {
                const arrayBuffer = base64ToArrayBuffer(content);
                const loader = new GLTFLoader();
                loader.parse(arrayBuffer, '', (gltf) => {
                    gltf.scene.scale.set(100, 100, 100);

                    setTimeout(() => {
                        const dx = (parseFloat(data?.object._Properties.pos_x._Value) * 100 || 0);
                        const dy = (parseFloat(data?.object._Properties.pos_y._Value) * 100 || 0);
                        const dz = (parseFloat(data?.object._Properties.pos_z._Value) * 100 || 0);

                        gltf.scene.position.set(
                            dx,
                            dy,
                            dz
                        );

                        gltf.scene.rotation.set(
                            (parseFloat(data?.object._Properties.rot_y._Value)  || 0) * Math.PI / 180,
                            (parseFloat(data?.object._Properties.rot_x._Value) || 0) * Math.PI / 180,
                            (parseFloat(data?.object._Properties.rot_z._Value) || 0) * Math.PI / 180
                        );

                    }, 2000);

                    // console.log('new component', gltf.scene);
                    gltf.scene.traverse((child: any) => {
                        if (child.isMesh && child.material) {
                            if (child.material.metalness !== undefined) child.material.metalness = 0.6;
                            if (child.material.roughness !== undefined) child.material.roughness = 0.3;
                            if (child.material.reflectivity !== undefined) child.material.reflectivity = 0.5;
                            child.material.needsUpdate = true;
                        }
                    });

                    setLoadedModels((models) => {
                        console.log('Adding model to loadedModels:', uniqueId);
                        return [...models, { id: uniqueId, type: 'gltf', scene: gltf.scene }];
                    });
                });
            } catch (e) {
                console.error('Error parsing GLTF:', e);
            }
        }
    } catch (error) {
        console.error('Error fetching component and display_table:', error);
    }

}


function validate_representation_data(data: any) {
    if (!data.object ||
        data.object?._Properties?.representation_hash?._Value === undefined ||
        data.object?._Properties?.pos_x?._Value === undefined ||      
        data.object?._Properties?.pos_y?._Value === undefined ||
        data.object?._Properties?.pos_z?._Value === undefined ||
        data.object?._Properties?.scale_x?._Value === undefined ||
        data.object?._Properties?.scale_y?._Value === undefined ||
        data.object?._Properties?.scale_z?._Value === undefined ||
        data.object?._Properties?.rot_x?._Value === undefined ||
        data.object?._Properties?.rot_y?._Value === undefined ||
        data.object?._Properties?.rot_z?._Value === undefined) {
        return false;
    }
    return true;
}